module.exports = __webpack_public_path__ + "assets/img/searchInFo.f264ba7f.webp";